export const LAIRD_RG1XX = 'LAIRD_RG1XX'
export const RAK7240 = 'RAK7240' // Onsite bridges pre 2023
export const RAK7289 = 'RAK7289' // Onsite + virtual bridges post 2023

export default [
  LAIRD_RG1XX,
  RAK7240,
  RAK7289,
]
